import * as R from 'ramda'
import netIncome from './netIncome'
import llBills from './llBills'

export default (billsByPropertyID, owners) => {
	let llBills = R.map(propertyBills => {
		return R.reduce((sum, bill) => {
			if(owners[bill.partyID]) return sum + bill.amount
			return sum + 0
		}, 0)(propertyBills)
	})(billsByPropertyID)
	llBills.total = R.pipe(R.values, R.reduce(R.add, 0))(llBills)

	return llBills
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/llBills.js